/*global _ */
import {Vue} from '~/addiesaas'
import { createNamespacedHelpers } from 'vuex'
import { default as timerStore, absoluteNamespace } from '../../vuexstore/modules/timer'
const { mapGetters, mapActions } = createNamespacedHelpers(absoluteNamespace)

const  EventBus = window.VueEventBus
import {getNow, seconds2Hours} from '../../lib/dates'

export default {
  data() {
    return {
      globalCountdownInterval: null,
      timerCountdownsRemaining: {}
    }
  },
  computed: {
    ...mapGetters(Object.keys(timerStore.getters)), //timerCountdowns
    timerIsRunning() {
      return this.timerRemaining > 1
    },
    currentTimer() {
      return this.timerCountdowns[this.currentLocationId]
    },
    timerStartTime() {
      return (this.currentTimer || {}).startValue
    },
    timerEndTime() {
      return (this.currentTimer || {}).endValue
    },

    needsToShowTimer() {
      const cartItems = this.currentCartItems || {}
      return _.some(cartItems, 'useTimer')
    },
    showGlobalTimerMessage() {
      const showGlobalTimer = this.$store.getters['RacewayBooking/pages/showingGlobalTimer'] || false
      return showGlobalTimer && this.needsToShowTimer && this.timerIsRunning
    },
    timerRemaining() {
      return this.timerCountdownsRemaining[this.currentLocationId]
    },
    timerRemainingFormatted() {
      const timerRemaining = this.timerRemaining
      if (timerRemaining){
        return seconds2Hours(timerRemaining)
      }
      return ''
    }
  },
  watch: {

  },
  created() {
    this.runGlobalCountdown()
    this.globalCountdownInterval = setInterval(() => this.runGlobalCountdown(), 1000)
  },
  beforeDestroy() {
    if (this.globalCountdownInterval) {
      clearInterval(this.globalCountdownInterval)
    }
  },
  methods: {
    ...mapActions(Object.keys(timerStore.actions)), //startCountdownTimer/updateCountdownTimer/stopCountdownTimer
    runGlobalCountdown() {
      _.forOwn(this.timerCountdowns, ({endValue}, id) => {
        const now = getNow()
        const currentValue = now.valueOf()// milliseconds
        const remaining = Math.floor(_.toFinite((endValue - currentValue) / 1000))// convert to seconds
        if (remaining > 0) {
          Vue.set(this.timerCountdownsRemaining, id, remaining)
          EventBus.$emit('timer.tick', remaining, id)
        } else {
          Vue.delete(this.timerCountdownsRemaining, id)
          this.unsetCountdownTimer({id})
          EventBus.$emit('timer.timeout', id)
        }
      })
    },
    // duration is in seconds
    startTimer(duration) {
      const id = this.currentLocationId
      // convert duration (seconds) to milliseconds
      if (!_.isObject(duration)) {
        duration *= 1000
      }
      const now = getNow()
      const startValue = now.valueOf()
      // plus(milliseconds)
      const end = now.plus(duration)
      const endValue = end.valueOf() //milliseconds
      this.setCountdownTimer({endValue, startValue, id})
    },
    stopTimer() {
      const id = this.currentLocationId
      if (_.has(this.timerCountdownsRemaining, id)) {
        Vue.delete(this.timerCountdownsRemaining, id)
      }
      if (this.currentTimer) {
        this.unsetCountdownTimer({id})
      }
    },
    mayResetCountdownTimer() {
      if (!this.needsToShowTimer) {
        this.stopTimer()
      }
    }
  }
}
